<template>
  <div class="major">
    <div class="major-header">
      <i
        @click.stop="goBack"
        class="iconfont icon-xiangyou"
        :class="[isDirection ? '' : 'mirrorRotateLevel']"
      ></i>
      <span>{{ "status" }}</span>
    </div>
    <div class="major-main">
      <div class="major-main-title">
        <span class="amount">+ 1,000,000,000</span><span>sats</span>
      </div>
      <van-cell-group>
        <div v-for="(item, index) in items" :key="index">
          <van-cell v-if="item.isCell" class="major-main-cell">
            <div slot="title" class="major-main-cell-title">
              {{ item.text }}
            </div>
            <div slot="label" class="major-main-cell-label">
              {{ detailDatas[item.field] }}
            </div>
            <span slot="extra" class="cell-copy copy-icon"
              ><i
                class="copy iconfont icon-fuzhi"
                @click="handleCopy"
                data-clipboard-text="https://t.me/SuperExOfficial"
              ></i
            ></span>
          </van-cell>
          <van-cell v-else-if="item.isGrid" class="major-main-grid">
            <div slot="title" class="major-main-grid-title">
              {{ item.text1 }}
            </div>
            <div slot="label" class="major-main-grid-label">
              <span class="major-main-grid-label-text">{{ detailDatas[item.field1] }}</span>
              <span v-if="item.isCopy" class="copy-icon"
                ><i
                  class="copy iconfont icon-fuzhi"
                  @click="handleCopy"
                  data-clipboard-text="https://t.me/SuperExOfficial"
                ></i
              ></span>
            </div>
            <div slot="default" class="grid-right">
              <div class="grid-right-title">{{ item.text2 }}</div>
              <div class="grid-right-label">{{ detailDatas[item.field2] }}</div>
            </div>
          </van-cell>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Clipboard from "clipboard";
import { Cell, CellGroup, Toast } from "vant";
import { removeCookie, removeLanguage } from "../../utils/auth";
export default {
  name: "TokenDetails",
  components: {
    vanCellGroup: CellGroup,
    vanCell: Cell
  },
  data() {
    return {
      items: [
        { text: "发送地址", field: "sendAd", isCopy: true, isCell: true },
        { text: "接收地址", field: "acceptAd", isCopy: true, isCell: true },
        {
          text1: "记录时间",
          field1: "rdTime",
          text2: "类型",
          field2: "type",
          isGrid: true
        },
        {
          text1: "网络费用",
          field1: "netCast",
          text2: "网络类型",
          field2: "netType",
          isGrid: true
        },
        {
          text1: "交易哈希",
          field1: "dealHash",
          text2: "Ticker:ID",
          field2: "TickerId",
          isGrid: true,
          isCopy: true
        }
      ],
      // 详情数据
      detailDatas: {
        sendAd: 'bc1ppnags|wuxwhmhv9zw5eemnckde3t90394eqwv|3z2||4wwc38zsk366v5',
        acceptAd: 'bc1ppnags|wuxwhmhv9zw5eemnckde3t90394eqwv|3z2||4wwc38zsk366v5',
        rdTime: '2023/12/19 17:29:59',
        type: 'Deploy',
        netCast: '0.000433 BTC',
        netType: 'Bitcoin',
        dealHash: 'ac3b7c3b7c...0d780d7',
        TickerId: 'PIPE:84761',
      }
    };
  },
  computed: {
    ...mapGetters([
      "token",
      "styleType",
      "isDirection",
      "languageName",
      "language",
      "isApp"
    ])
  },

  mounted() {},

  methods: {
    // 复制
    handleCopy() {
        console.log('点击了复制');
      var clipboard = new Clipboard(".copy");
      clipboard.on("success", e => {
        Toast.success(this.$t("300027"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        Toast.fail(this.$t("300028"));
        // 释放内存
        clipboard.destroy();
      });
    },
    goBack() {
      // console.log(this.$route)
      if (this.$route.query.isApp) {
        removeCookie();
        removeLanguage();
        this.$jsBridge.callHandler(this.$jsBridgeCmd.goBack, {}, data => {});
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variableName.scss";
@import "../../style/mixin";
.major {
  &-header {
    width: 100%;
    // background-color: #17171a;
    z-index: 9999;
    // position: absolute;
    padding-top: torem(44);
    padding: 0 torem(19);
    box-sizing: border-box;
    height: torem(51);
    // background-color: #000000;
    display: flex;
    align-items: center;
    text-align: start;
    i {
      font-size: torem(16);
      // width: torem(9.62);
      // height: torem(17);
      color: #333333;
    }
    span {
      font-size: torem(16);
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.9);
      margin: 0 auto;
    }
  }
  &-main {
    padding: torem(20) torem(16) torem(16) torem(16);
    &-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: torem(24);
      color: rgba(0, 0, 0, 0.85);
      .amount {
        padding-right: torem(8);
      }
    }
    .cell-copy {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }

    .copy-icon {
      color: rgba(0, 0, 0, 0.8);
    }
    .grid-right {
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      &-title {
        font-size: torem(10);
      }
      &-label {
        font-size: torem(12);
        color: rgba(0, 0, 0, 0.8);
      }
    }
    &-cell {
      &-title {
        font-size: torem(10);
        color: rgba(0, 0, 0, 0.6);
      }
      &-label {
        width: torem(240);
        font-size: torem(10);
        word-break: break-all;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.8);
      }
    }
    &-grid {
      &-title {
        font-size: torem(10);
        color: rgba(0, 0, 0, 0.6);
      }
      &-label {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      &-label-text {
        width: torem(156);
        padding-right: torem(8);
        font-size: torem(12);
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: rgba(0, 0, 0, 0.8);
      }
      /deep/ .van-cell__title {
        width: torem(156);
        padding-right: torem(16);
      }
      /deep/ .van-cell__value {
        flex-shrink: 0;
      }
    }
    /deep/ .van-cell {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InscriptionArea/tokenDetails.vue